<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户报表</el-breadcrumb-item>
      <el-breadcrumb-item>商品销售</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      正在建设中...
    </el-card>
  </div>
</template>
<script>
import printJS from 'print-js'
export default {
  data() {
    return {

      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list',
        C_table_name: 'guest_list',
        query: '',
        pageNum: 1,
        pageSize: 10000
      },
      guestList: [],
      //  recordCount: 0,
      total: 0
    }
  },
  created() {
    this.getguestList();
  },
  methods: {
    print_query() {
      printJS({ printable: 'query_print', type: 'html', scanStyles: false, css: ['https://qiniu.smartpilot.cn/myreport.css'], style: '' })
    },
    async getguestList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      // console.log(JSON.parse(res.data))
      this.guestList = JSON.parse(res.data)[0].dataList;

      if (!this.guestList) return;
      this.guestList.forEach(function(item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    }
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important ;
  background-color: #f2f6fc;
}
.el_row_two {
  margin-top: 30px;
}
</style>
